import { useMemo } from 'react';
import { useMatchMedia } from 'src/hooks/useMatchMedia';

/**
 * Detects if the current device is an Android device
 * @returns true if running on Android, false otherwise
 */
const isAndroidDevice = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  // Check for Android in user agent
  return /android/i.test(ua);
};

/**
 * It is known issue that the searchable prop on the PosSelect component causes unexpected dismiss on Android devices,
 * where adding input field in the dropdown is not a good experience because input will trigger the mobile keyboard,
 * which will trigger the window resize/blur event and auto dismisses the dropdown, especially when you are putting the
 * Select component on a modal.
 *
 * Please replace with https://react-select.com/ going forward, which has better and consistent behavior on web and mobile.
 *
 * This hook is used to sanitize the searchable prop by disabling it on Android devices.
 * @param searchable the original searchable
 * @returns force to not searchable on Android devices, otherwise return the original searchable value
 */
export const useSanitizedSearchable = (searchable?: boolean) => {
  const isMobile = useMatchMedia('mobile');
  const isAndroid = useMemo(() => isMobile && isAndroidDevice(), [isMobile]);

  return Boolean(!isAndroid && searchable);
};
